import React from "react";
import { Link } from "react-router-dom";
import { ASSETS, BRAND, buildWhatsAppLink } from "../lib/api";
import { useT } from "../i18n/LanguageContext";
import { Phone } from "lucide-react";
import WhatsAppButton from "./WhatsAppButton";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer
      data-testid="bv-footer"
      className="relative bv-grain"
      style={{ background: "#0F1D14", color: "#F5EFE0" }}
    >
      <div className="gold-divider-double" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={ASSETS.crest} alt="HBS" className="h-16 bg-white rounded-sm p-1.5" />
            <div>
              <div className="font-serif-bv text-2xl tracking-wider text-[#D4AF37]">HBS</div>
              <div className="text-[9px] tracking-[0.32em] text-[#E8C857]/70 uppercase mt-1">Hayti Bon Sèvis Shipping</div>
            </div>
          </div>
          <p className="font-serif-bv italic text-2xl text-[#D4AF37] mt-6">
            "Liberté ou la Mort"
          </p>
          <p className="text-sm text-[#F5EFE0]/70 mt-2 max-w-md">
            {t("footer.motto_caption")} {t("footer.tag")}
          </p>
          <div className="mt-6 space-y-3">
            <a
              href={`tel:${BRAND.phone_e164}`}
              data-testid="footer-phone"
              className="inline-flex items-center gap-2 text-[#F5EFE0]/85 hover:text-[#D4AF37] text-sm"
            >
              <Phone size={14} className="text-[#D4AF37]" /> {BRAND.phone}
            </a>
            <div>
              <WhatsAppButton variant="inline" label="WhatsApp" testid="footer-whatsapp" />
            </div>
          </div>
        </div>

        <div>
          <h4 className="font-serif-bv text-lg text-[#D4AF37] mb-4 uppercase tracking-widest">{t("footer.col_order")}</h4>
          <ul className="space-y-2 text-sm text-[#F5EFE0]/80">
            <li><a href="#ledger" className="hover:text-[#D4AF37]">{t("nav.ledger")}</a></li>
            <li><a href="#missions" className="hover:text-[#D4AF37]">{t("nav.missions")}</a></li>
            <li><a href="#trading-posts" className="hover:text-[#D4AF37]">{t("nav.trading_posts")}</a></li>
            <li><a href="#legacy" className="hover:text-[#D4AF37]">{t("nav.legacy")}</a></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37]">Contact</Link></li>
            <li><Link to="/commission" className="hover:text-[#D4AF37]">{t("nav.commission_full")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif-bv text-lg text-[#D4AF37] mb-4 uppercase tracking-widest">{t("footer.col_posts")}</h4>
          <ul className="space-y-2 text-sm text-[#F5EFE0]/80">
            <li>Miami, Florida</li>
            <li>Montréal, Québec</li>
            <li>Santiago, R.D.</li>
            <li>Port-au-Prince, Haïti</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#D4AF37]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs tracking-[0.2em] uppercase text-[#F5EFE0]/60">
            {t("footer.copyright")}
          </p>
          <p className="text-xs tracking-[0.2em] uppercase text-[#F5EFE0]/60">
            Kreyòl • Français • English • Español • Português
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
